/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_Free_ToolsInputs */

const en_directory_footer_link_free_tools = /** @type {(inputs: Directory_Footer_Link_Free_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free tools`)
};

const zh_directory_footer_link_free_tools = /** @type {(inputs: Directory_Footer_Link_Free_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费工具`)
};

/**
* | output |
* | --- |
* | "Free tools" |
*
* @param {Directory_Footer_Link_Free_ToolsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_free_tools = /** @type {((inputs?: Directory_Footer_Link_Free_ToolsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_Free_ToolsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_free_tools(inputs)
	return zh_directory_footer_link_free_tools(inputs)
});
export { directory_footer_link_free_tools as "directory.footer.link_free_tools" }